<template>
  <edit-user-form />
</template>

<script>
import EditUserForm from "@/components/3pl/Settings/UsersAndGroups/Users/EditUser/index";
export default {
  components: {
    EditUserForm,
  },
};
</script>

<style></style>
